import Typography from '@components/v2/ui/Typography/Typography';
import usePlatform from '../../../../hooks/usePlatform';
import { buildShortcutKeys, isApplePlatform } from './shortcut.utils';

const SIZE_CONFIG = {
  small: { variant: 'micro1', px: 0.5, py: 0.25 },
} as const;

type ShortcutSize = keyof typeof SIZE_CONFIG;

interface ShortcutProps {
  keys: string[];
  size?: ShortcutSize;
  testId?: string;
}

const Shortcut = ({ keys, size = 'small', testId }: ShortcutProps) => {
  const { platform } = usePlatform();
  const { variant, px, py } = SIZE_CONFIG[size];

  const content = buildShortcutKeys(keys, isApplePlatform(platform));

  return (
    <Typography
      variant={variant}
      color="text.secondary"
      component="span"
      testId={testId}
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        px,
        py,
        borderRadius: `${theme.shape.borderRadiusMd}px`,
        backgroundColor: 'secondary.light',
      })}
    >
      {content}
    </Typography>
  );
};

export default Shortcut;
